var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSquiggleVertical = function SvgSquiggleVertical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 4 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0v16h3.03c.15-.52.29-1.26.27-2.19-.06-2.53-.86-4.21-1.64-5.87C.9 6.32.15 4.73.13 2.4c0-.83.09-1.7.2-2.4H0Z"
  })));
};
export default SvgSquiggleVertical;